import React from 'react'
import styled from 'styled-components'

const HighlightIconFilter = styled.div`
  img {
    filter: invert(0%) sepia(0%) saturate(2) hue-rotate(233deg) brightness(25%)
      contrast(75%) !important;
  }
`
type Props = {
  children: React.ReactNode
}

const TaxonomyHeader = ({ children }: Props) => {
  return (
    <HighlightIconFilter>
      <div className="flex items-center gap-4">{children}</div>
    </HighlightIconFilter>
  )
}

export default TaxonomyHeader
